var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalCustomerSelect",
          attrs: {
            id: "modal-center",
            size: "xl",
            title: _vm.title,
            "no-fade": true,
            "hide-footer": "",
            scrollable: ""
          }
        },
        [
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-navbar",
                [
                  _c(
                    "b-navbar-nav",
                    [
                      _c(
                        "b-form",
                        {
                          attrs: { inline: "" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSearch()
                            }
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "mb-1 mr-2",
                            attrs: {
                              size: "sm",
                              debounce: "500",
                              placeholder: "Поиск"
                            },
                            model: {
                              value: _vm.filters.query,
                              callback: function($$v) {
                                _vm.$set(_vm.filters, "query", $$v)
                              },
                              expression: "filters.query"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-select",
                            {
                              staticClass: "mb-1 mr-2",
                              attrs: { id: "input_town", size: "sm" },
                              model: {
                                value: _vm.filters.town,
                                callback: function($$v) {
                                  _vm.$set(_vm.filters, "town", $$v)
                                },
                                expression: "filters.town"
                              }
                            },
                            [
                              _c("option", { domProps: { value: -1 } }, [
                                _vm._v("Все города")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.towns, function(option) {
                                return _c(
                                  "option",
                                  { domProps: { value: option.id } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(option.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-1 mr-1",
                              attrs: { size: "sm", variant: "outline-success" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onSearch()
                                }
                              }
                            },
                            [_vm._v("\n              Применить\n            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                ref: "customers",
                staticClass: "mb-0",
                attrs: {
                  id: "customers",
                  striped: "",
                  hover: "",
                  small: "",
                  "thead-class": "top-fixed-thead thead-light",
                  "tbody-tr-class": "pointer-cell",
                  "table-class": "text-small",
                  responsive: "",
                  "show-empty": "",
                  "empty-text": _vm.$t("message.common.emptyTable"),
                  busy: _vm.isBusy,
                  items: _vm.items,
                  fields: _vm.fields,
                  "no-provider-filtering": "",
                  "no-provider-paging": "",
                  "no-provider-sorting": ""
                },
                on: {
                  "update:busy": function($event) {
                    _vm.isBusy = $event
                  },
                  "row-clicked": _vm.rowClickHandler
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(phone)",
                    fn: function(row) {
                      return [
                        _c("a", { attrs: { href: _vm.telUrl(row.value) } }, [
                          _vm._v(_vm._s(_vm.phoneString(row.value)))
                        ])
                      ]
                    }
                  },
                  {
                    key: "cell(urflag)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.urFlagString(row.item.urflag)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("pagination-footer", {
                attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
                on: {
                  "update:perPage": function($event) {
                    _vm.perPage = $event
                  },
                  "update:per-page": function($event) {
                    _vm.perPage = $event
                  },
                  "page-click": _vm.onPagination,
                  "per-page-change": _vm.onPerPageChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bce99d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bce99d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/CustomerTableSelect.vue
// module id = null
// module chunks = 